import { postRequest } from "../../../../Script/apiMethods"

export const getCertData = async (file) => {
  return new Promise(async (resolve, reject) => {
    try {
      if (!window.navigator.onLine) {
        throw "P2BCODE::NETWORK_ERROR"
      }

      if (!file || !(file instanceof File)) {
        throw new Error("Valid File object is required")
      }

      const formData = new FormData()
      formData.append("file", file)

      const data = await postRequest("/api/digi-sign/v1/verify", formData, {
        timeout: 10000,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })

      resolve(data)
    } catch (error) {
      console.error("Document upload error:", error)
      reject(error)
    }
  })
}
